<template>
  <v-form lazy-validation @submit.prevent="onLogin" id="loginForm" ref="form">
    <v-card-text>
      <v-text-field
        label="Usuário (e-mail)"
        name="login"
        type="text"
        v-model="payload.email"
        :rules="userRules"
        required
        background-color="white"
        solo
      ></v-text-field>
      <v-text-field
        v-if="!showNewPassword"
        id="password"
        label="Senha"
        name="password"
        type="password"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        background-color="white"
        solo
        append-icon="mdi-eye-off"
        @click:append="showNewPassword = true"
      ></v-text-field>
      <v-text-field
        v-if="showNewPassword"
        id="password"
        label="Senha"
        name="password"
        type="text"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        background-color="white"
        solo
        append-icon="mdi-eye"
        @click:append="showNewPassword = false"
      ></v-text-field>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col>
          <div class="text-center mb-3">
            <v-btn
              color="secondary"
              :style="{
                backgroundColor: '##f4d35e',
              }"
              type="submit"
              id="btnEntrar"
            >
              Entrar
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { authAPI } from "@/apis";

import Auth from "@/Auth.js";
export default {
  computed: {
    ...mapGetters(["token", "forcedLogout"]),
  },
  data() {
    return {
      payload: {},
      passwordRules: [(v) => !!v || "O campo senha é obrigatório"],
      userRules: [(v) => !!v || "O campo usuário é obrigatório"],
      valid: true,
      expired: Auth.getItem("expired"),
      lastRoute: Auth.getItem("last_route") || null,
      showNewPassword: false,
    };
  },
  methods: {
    ...mapActions([
      "setToken",
      "setUser",
      "setIsLogged",
      "setLoading",
      "setForcedLogout",
      "setFullAdmin",
    ]),
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async onLogin() {
      var isValid = await this.check();
      if (!isValid) return;
      this.setLoading(true);
      authAPI
        .login(this.payload)
        .then(({ data }) => {
          var user = data.data.userToken;
          if (user) {
            delete user.senha;

            if (user.email === "admin@admin.com.br") {
              this.setFullAdmin(true);
            } else {
              this.setFullAdmin(false);
            }

            this.setUser(user);
            this.setForcedLogout(false);
            this.setToken(data.data.accessToken);
            this.$http.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${data.data.accessToken}`;

            this.$notification.success("Logado com sucesso!", { timer: 3 });
            this.$forceUpdate();
            if (
              this.expired === true &&
              this.forcedLogout === false &&
              this.lastRoute !== "/auth/login"
            ) {
              Auth.setItem("expired", false);
              this.$router.push(this.lastRoute);
            } else {
              this.$router.push("/inscricao/auth/dashboard");
            }
          } else {
            console.log("Ocorreu um erro: usuario retornado foi : ", data);

            this.$notification.error(
              "Aconteceu um problema, contate o administrador do sistema",
              { timer: 10 }
            );
          }
          this.setLoading(false);
        })
        .catch((err) => {
          console.log("Erro ao fazer login: ", err);
          this.setLoading(false);

          if (err.response && err.response.data.usuarioBloqueado) {
            this.$notification.error(err.response.data.message, {
              timer: 10,
            });
          } else if (err.response && err.response.data.credencialErrada) {
            this.$notification.error(
              "Por gentileza, verifique as credenciais digitadas",
              { timer: 5 }
            );
          } else {
            this.$notification.error(
              "Ocorreu um erro, entre em contato com o administrador do sistema.",
              { timer: 10 }
            );
          }
          this.setForcedLogout(true);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  a {
    white-space: normal;
  }
}
</style>
